<template>
  <div class="chart-container1 w-100 rounded-2 m-0 overflow-hidden" :id="chartId"></div>
</template>

<script>
/* eslint-disable */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { scaleLinear } from "d3-scale";
import globalVar from "@/assets/globalVar.json"

export default {
  props: {
    data_country: {
      type: Object,
      required: true,
    },
    currentChartField: {
        type: String,
        required: true,
    },
    chartId:{
      type:String,
      required:true,
    }
  },
  data() {
    return {
      data: [],
      selectedCountry: null
    };
  },
  methods: {
    getColor(value) {
      let rangesData = [];
      if (this.currentChartField === "opportunity"){
        rangesData = globalVar.opport
      } else {
        rangesData = globalVar.risk
      }

      let category = '';
      if (value >= 5) {
        category = rangesData[4].color;
      } else {
        category = '#808080'
        for (let i = 0; i < rangesData.length; i++) {
          if(value >= rangesData[i].rangeMin - 0.005 && value <= rangesData[i].rangeMax - 0.005){
            category = rangesData[i].color;
            break;
          }
        }
      }

      return category;
    },
    GetCountry() {
      this.countryIn = this.$route.params.element;
    },
    updateData() {
      if (!this.countryIn)
        return
      const countryData = this.data_country;
      this.data.forEach((category, index) => {
        const key = category.id;
        const value = parseFloat(countryData[key].value);
        
        this.data.value = value;

        const colorScale = scaleLinear()
          .domain([0, 2, 3.5, 4.5, 5])
          .range(['#00FF00', '#FFD300', '#FFA500', '#FF0000']);

        this.data[index] = {
          ...this.data[index],
          columnSettings: {
            fill: am4core.color(this.getColor(value)),
          }
        };
      });
      this.chart.data = this.data;
    },
    createChart() {
      am4core.useTheme(am4themes_animated);

      this.chart = am4core.create(this.chartId, am4charts.XYChart);
      this.chart.padding(40, 40, 40, 40);
      this.chart.background.fill = am4core.color("#ffffff");
      
      let categoryAxis = this.chart.yAxes.push(new am4charts.CategoryAxis());
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.dataFields.category = "category";
      categoryAxis.renderer.minGridDistance = 0;
      categoryAxis.renderer.inversed = true;
      categoryAxis.renderer.grid.template.disabled = true;

      var subtitle = this.chart.titles.create();
      subtitle.text = "From 1 Negligible Risk) to 5 (Severe Risk)";
      subtitle.fontSize = 15;
      subtitle.marginBottom = 15;
      
      var title = this.chart.titles.create();
      if(this.currentChartField == 'risk'){
        title.text = "Risk Assessment by pillar";
        subtitle.text = "From 1 (Negligible Risk) to 5 (Severe Risk)";
      } else{
        title.text = "Opportunity Assessment by pillar"
        subtitle.text = "From 1 (low opportunity) to 5 (very high opportunity)";
      }
      title.fontSize = 25;
      title.marginBottom = 2;
      
      let valueAxis = this.chart.xAxes.push(new am4charts.ValueAxis());
      valueAxis.min = 1;
      valueAxis.max = 5;
      valueAxis.strictMinMax = true;
      valueAxis.renderer.minGridDistance = 50;
      valueAxis.renderer.extraMax = 0;

      let series = this.chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.categoryY = "category";
      series.dataFields.valueX = "value";
      series.columns.template.strokeOpacity = 0;
      series.columns.template.column.cornerRadiusBottomRight = 5;
      series.columns.template.column.cornerRadiusTopRight = 5;

      

      // let labelBullet = series.bullets.push(new am4charts.LabelBullet());
      // labelBullet.label.html = "{values.valueX.workingValue.formatNumber('#.00as')}";


      // labelBullet.label.horizontalCenter = "right"; // align to start (left side of the bar)
      // labelBullet.locationX = 0; // place label at the start of the bar
      // labelBullet.valign = "middle"
      // labelBullet.label.dx = -10; // optional: shift a bit to the left for spacing

      let valueLabel = series.columns.template.createChild(am4core.Label);
      valueLabel.text = "{values.valueX.workingValue.formatNumber('#.00as')}";
      valueLabel.valign = "middle";
      valueLabel.dx = 10;
      valueLabel.strokeWidth = 0;
    
      

      series.columns.template.adapter.add("fill", function(fill, target) {
        return target.dataItem.dataContext.columnSettings.fill;
      });



 
      let labelBulletArrow = series.bullets.push(new am4charts.LabelBullet());
      labelBulletArrow.label.horizontalCenter = "left";
      categoryAxis.renderer.labels.template.adapter.add("html", function(text, target) {
        const dataItem = target.dataItem?.dataContext;
        if(dataItem == undefined){
          return('')
        }
        if(dataItem.id == 'pillar1' || dataItem.id == 'pillar2' || dataItem.id == 'pillar3' || dataItem.id == 'pillar4'){
          if(dataItem.direction == 'increase'){
            return(target.text+"  <span style=\"color: red; font-size: 30px\">🡅</span")
          }
          if(dataItem.direction == 'decrease'){
            return(target.text+"  <span style=\"color: green; font-size: 30px\">🡇</span")
          }
          if(dataItem.direction == null){
            return(target.text+"  <span style=\"color: grey; font-size: 30px\">⚊</span")
          }
        }
        if(dataItem.id == 'macro' || dataItem.id == 'water' || dataItem.id == 'waste' || dataItem.id == 'energy'){

          //TODO Uncomment this in a year
          if(dataItem.direction == 'increase'){
            return(target.text+"  <span style=\"color: green; font-size: 40px\">🡅</span")
          }
          if(dataItem.direction == 'decrease'){
            return(target.text+"  <span style=\"color: red; font-size: 40px\">🡇</span")
          }
          if(dataItem.direction == null){
            return(target.text+"  <span style=\"color: grey; font-size: 40px\">⚊</span")
          }
          //TODO remove this line in a year
          // return(target.text+"  <span style=\"color: grey; font-size: 30px\">⚊</span")
        }
      });




      this.chart.exporting.menu = new am4core.ExportMenu();
      this.chart.exporting.menu.align = "left";
      if(this.currentChartField == 'risk'){
        this.chart.exporting.filePrefix = this.$route.params.element + "RiskByPillar"
      } else {
        this.chart.exporting.filePrefix = this.$route.params.element + "OpportunityByPillar"
      }
      this.chart.exporting.menu.verticalAlign = "top";
	    this.chart.exporting.menu.items = [{
		  "label": "...",
		  "menu": [
				  {
				"label": "Image",
				"menu": [
				  { "type": "png", "label": "PNG" },
				  { "type": "jpg", "label": "JPG" },
				  { "type": "svg", "label": "SVG" },
				  { "type": "pdf", "label": "PDF" }
				]
			  },
			{ "label": "Print", "type": "print" }
		  ]
      }];
      this.chart.data = this.data;
      this.updateData()


      let annotation = this.chart.chartContainer.createChild(am4core.Container);
      annotation.layout = "horizontal";
      annotation.align = "left";
      annotation.valign = "bottom";
      annotation.marginTop = 5;
      annotation.padding(0, 0, 0, 0);

      let label1 = annotation.createChild(am4core.Label);
      if(this.currentChartField == 'risk'){
        label1.html = `<span style="color: red; font-size: 14px;">🡅</span> <span style="font-size: 11px; color: #444;">higher risk since last update</span>`;
      } else {
        // label1.html = `<span style="color: grey; font-size: 14px;">⚊</span> <span style="font-size: 11px; color: #444;">No comparison possible</span>`;
        label1.html = `<span style="color: green; font-size: 14px;">🡅</span> <span style="font-size: 11px; color: #444;">higher opportunity since last update</span>`;  
      }
      label1.marginRight = 10;

      let label2 = annotation.createChild(am4core.Label);
      if(this.currentChartField == 'risk'){
        label2.html = `<span style="color: green; font-size: 14px;">🡇</span> <span style="font-size: 11px; color: #444;">lower risk since last update</span>`;
      } else {
        label2.html = `<span style="color: red; font-size: 14px;">🡇</span> <span style="font-size: 11px; color: #444;">lower opportunity since last update</span>`;
        // label2.html = `<span style="color: red; font-size: 14px;"></span>`;
      }
    }
    
  },
  mounted() {
    this.GetCountry();
    this.createChart();
    this.updateData();
  },
  beforeUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
  created() {
    const isOpportunity = this.currentChartField === "opportunity";
    this.data = isOpportunity
      ? [
          {
            category: "Macroeconomic",
            id: "macro",
            value: Math.round(this.data_country.macro.value * 100) / 100,
            direction: this.data_country.macro.evo,
            full: 5,
          },
          {
            category: "Water",
            id: "water",
            value: Math.round(this.data_country.water.value * 100) / 100,
            direction: this.data_country.water.evo,
            full: 5,
          },
          {
            category: "Waste",
            id: "waste",
            value: Math.round(this.data_country.waste.value * 100) / 100,
            direction: this.data_country.waste.evo,
            full: 5,
          },
          {
            category: "Energy",
            id: "energy",
            value: Math.round(this.data_country.energy.value * 100) / 100,
            direction: this.data_country.energy.evo,
            full: 5,
          }
        ]
      : [
          {
            category: "Economic & Business",
            id: "pillar1",
            value: Math.round(this.data_country.pillar1.value * 100) / 100,
            direction: this.data_country.pillar1.evo,
            full: 5,
          },
          {
            category: "Political & Geopolitical",
            id: "pillar2",
            value: Math.round(this.data_country.pillar2.value * 100) / 100,
            direction: this.data_country.pillar2.evo,
            full: 5,
          },
          {
            category: "Social & Societal",
            id: "pillar3",
            value: Math.round(this.data_country.pillar3.value * 100) / 100,
            direction: this.data_country.pillar3.evo,
            full: 5,
          },
          {
            category: "Environmental",
            id: "pillar4",
            value: Math.round(this.data_country.pillar4.value * 100) / 100,
            direction: this.data_country.pillar4.evo,
            full: 5,
          }
        ];
    }
};
</script>
